import DashboardLayout from "../../layouts/DashboardLayout";
import IdeaListComponent from "../../components/IdeaList/IdeaListPage";

export default function IdeaListPage() {
  return (
    <DashboardLayout>
      <IdeaListComponent />
    </DashboardLayout>
  );
}
